import { useEffect, useState } from 'react';

import { useLazyQuery } from '@apollo/client';

import CommissionType from 'src/features/finance/commissionStatement/constants/commissionType';
import { GET_FILTERED_COMMISSION_STATEMENTS } from 'src/graphql/queries/getCommissionStatements.query';
import formatCentsToLocaleCurrency from 'src/utils/finance';
import { onError } from 'src/utils/utils';

type UseFilteredCommissionStatementsInput = {
    commissionType: CommissionType;
};

export const useFilteredCommissionStatements = ({
    commissionType,
}: UseFilteredCommissionStatementsInput) => {
    const [tableFilters, setTableFilters] = useState({});
    const [filteredData, setFilteredData] = useState();

    const [filteredCommissionStatements, { loading }] = useLazyQuery(
        GET_FILTERED_COMMISSION_STATEMENTS,
        {
            fetchPolicy: 'network-only',
            onError: (error) => {
                return onError(error);
            },
            onCompleted: (data) => {
                const { filteredCommissionStatements } = data;
                setFilteredData(
                    filteredCommissionStatements.map((filteredCommissionStatement) => {
                        return {
                            ...filteredCommissionStatement,
                            totalCommission: formatCentsToLocaleCurrency(
                                filteredCommissionStatement?.totalCommission,
                                navigator.language
                            ),
                        };
                    })
                );
            },
        }
    );

    useEffect(() => {
        const fetchStatements = async () => {
            const filters = {
                id: tableFilters?.id,
                fromDate: tableFilters?.fromdate,
                toDate: tableFilters?.todate,
                status: tableFilters?.status?.replace(' ', '_'),
                partnerName: tableFilters?.partnername,
                search: tableFilters?.search,
                commissionType,
            };

            await filteredCommissionStatements({ variables: { filters } });
        };
        fetchStatements();
    }, [tableFilters, filteredCommissionStatements, commissionType]);

    return {
        loading,
        filteredData,
        setTableFilters,
    };
};

export default useFilteredCommissionStatements;
